
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { Dialog } from 'vant'
import { joinTeam, addTeam, updateTeamName, personBasic, teamBasic, firstJoin, endPanduan } from '@/api/lalisai'
export default {
directives: {
TransferDom
},
components: { XDialog },
name: 'card2',
props: {
top: {
type: String,
default: ''
},
first: {
type: String,
default: ''
}
},
data () {
return {
title: '',
firsttitle: '',
changetitle: '',
showdialog: false,
teamid: '',
obj: '',
partyId: '1',
showcreteam: false,
showteam: true
}
},
created () {
endPanduan({
partyId: this.partyId
}).then(res => {
if (!res.obj) {

this.showteam = false
} else {
if (this.$route.query.obj) {
let _this = this
console.log(this.$route.query.obj)
let temp = this.$route.query.obj.slice(0, this.$route.query.obj.length - 1)
this.obj = temp.split(',')
if (this.obj[0] != this.accountid) {
firstJoin({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
joinTeam({
inviter: this.obj[0],
bInviter: this.accountid,
id: this.obj[1],
partyId: this.partyId
}).then(res => {
if (res.obj) {
this.$vux.toast.text('入队成功')
this.$emit('getList', '')
this.getinfor()
} else {
this.$vux.toast.text(res.msg)
this.$router.push({ name: 'lalisaiTeam' })
this.getinfor()
console.log('123123')
}
})
})
} else {
Dialog.alert({
message: '自己不能邀请自己入队哦！'
}).then(() => {
this.$router.push({ name: 'lalisaiTeam' })
})
}
} else {
this.getinfor()
}
}
})
},
mounted () {
},
computed: {
accountid () {
return this.$store.state.user.accountid
}
},
watch: {
title: function () {
var obj = document.getElementById('title_content')
if (this.title.length >= 6) {
obj.style.cssText = 'font-size: 18px;'
} else {
obj.style.cssText = 'font-size: 25px;'
}
},
first: function () {
if (this.first == '1') {
this.showcreteam = true
}
}
},
methods: {
Team () {
this.$router.push({ name: 'lalisaiTeam' })
},
modify () {
this.showdialog = true
this.changetitle = this.title
},
getinfor () {
personBasic({
accountid: this.accountid,
partyId: this.partyId
}).then(res => {
if (res.obj.llsPersonBasicinfo.teamId == null) {

this.showcreteam = true

} else {
this.teamid = res.obj.llsPersonBasicinfo.teamId
this.getteaminfor()
}
})
},
createteam () {
if (this.firsttitle.length < 1) {
this.$vux.toast.text('请输入队名')
return false
}
if (this.firsttitle.length > 8) {
this.$vux.toast.text('请最多输入8个字')
return false
}
addTeam({
accountid: this.accountid,
teamName: this.firsttitle,
partyId: this.partyId
}).then(res => {
if (res.obj) {
this.title = this.firsttitle
this.$emit('getList', '')
this.getinfor()
this.showcreteam = false
} else {
this.$vux.toast.text(res.msg)
}
})
},
getteaminfor () {
teamBasic({
teamId: this.teamid
}).then(data => {
this.title = data.obj.team.teamName
})
},
change () {
if (this.changetitle.length < 1) {
this.$vux.toast.text('请输入修改的队名')
return false
}
if (this.changetitle.length > 8) {
this.$vux.toast.text('请最多输入8个字')
return false
}
updateTeamName({
id: this.teamid,
teamName: this.changetitle,
partyId: this.partyId
}).then(res => {
if (res.obj) {
this.title = this.changetitle
this.$emit('getList', '')
this.showdialog = false
} else {
this.$vux.toast.text(res.msg)
}
})
}
}
}
